import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "8px",
	viewBox: "0 0 12 8",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Combined Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-667.000000, -954.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-7",
					transform: "translate(643.000000, 931.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M30,23 C31.758499,23 33.516998,24.0307729 35.2754971,26.0923188 L35.5049018,26.3670328 C35.8059392,26.7352929 35.8059401,27.2646314 35.5049039,27.6328925 C33.6699359,29.8776308 31.834968,31 30,31 C28.241501,31 26.483002,29.9692271 24.7245029,27.9076812 L24.4950982,27.6329672 C24.1940608,27.2647071 24.1940599,26.7353686 24.4950961,26.3671075 C26.3300641,24.1223692 28.165032,23 30,23 Z M30,25 C28.8954305,25 28,25.8954305 28,27 C28,28.1045695 28.8954305,29 30,29 C31.1045695,29 32,28.1045695 32,27 C32,25.8954305 31.1045695,25 30,25 Z",
						id: "Combined-Shape"
					})
				})
			})
		})
	]
});
export default SvgView;
